'use strict';
import membersManageTemplate from './controllers/admin/members-manage.html';
import personnelDetailTemplate from './controllers/personnel-detail.html';
import teamTypesManageTemplate from './controllers/team-types-manage.html';
import teamsDetailTemplate from './controllers/teams-detail.html';
import personnelHomeTemplate from './ngTemplates/personnel-home.html';


export const personnelStates = {
  personnelHome: 'app.personnel-home',
  personnelDetail: 'app.personnel-detail',
  teamsDetail: 'app.teams-detail',
  teamTypesManage: 'app.team-types-manage',
  membersManage: 'app.members-manage',
};

routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(personnelStates.personnelHome, {
      title: 'personnel.home.header.label',
      url: '/personnel',
      views: {
        'appContent': {
          template: personnelHomeTemplate,
          controller: 'PersonnelHomeController',
        },
      },
    })

    .state(personnelStates.personnelDetail, {
      title: 'personnel.individuals.profile.header.label',
      url: '/personnel/personnel-detail/:personId',
      views: {
        'appContent': {
          template: personnelDetailTemplate,
          controller: 'PersonnelDetailController',
        },
      },
      resolve: {
        person: ['$stateParams', 'PersonDomain', 'currentUser', resolvePerson],
      },
    })

    .state(personnelStates.teamsDetail, {
      title: 'teams.details.header.label',
      url: '/personnel/teams-detail/:teamId',
      views: {
        'appContent': {
          template: teamsDetailTemplate,
          controller: 'TeamsDetailController',
        },
      },
      resolve: {
        team: ['$stateParams', 'TeamDomain', 'currentUser', resolveTeam],
      },
    })

    .state(personnelStates.teamTypesManage, {
      title: 'teams.types.manage.header.label',
      url: '/personnel/manage-team-types',
      views: {
        'appContent': {
          template: teamTypesManageTemplate,
          controller: 'TeamTypesManageController',
        },
      },
    })

    .state('app.members-manage', {
      title: 'invites.manage.header.label',
      url: '/personnel/manage-members',
      views: {
        'appContent': {
          template: membersManageTemplate,
          controller: 'MembersManageController as membersMgmt',
        },
      },
    });

  function resolvePerson($stateParams, PersonDomain) {
    if ($stateParams.personId) {
      return PersonDomain.$get($stateParams.personId);
    } else {
      return null;
    }
  }

  function resolveTeam($stateParams, TeamDomain) {
    if ($stateParams.teamId) {
      return TeamDomain.$get($stateParams.teamId);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/router.js